module.exports = __webpack_public_path__ + "static/media/image-thumb-4.de356fdb.jpeg";